"use client";

import { signOut } from "@/lib/auth-client";
import { useRouter } from "next/navigation";
import { DropdownMenuItem } from "../ui/dropdown-menu";

export function LogoutDropdownMenuItem() {
  const router = useRouter();
  const doLogout = async () => {
    await signOut({
      fetchOptions: {
        onSuccess: () => {
          router.push("/");
        },
      },
    });
  };

  return <DropdownMenuItem onClick={doLogout}>Log out</DropdownMenuItem>;
}
